import { buildSpectateUrl } from '../../Utils/Spectate';
import { MORE_GAMES_URL_ENDPOINT } from './constants';
import { post } from '~shared/utils/http';
export const fetchEvents = async (
    tournamentSlug,
    categorySlug,
    sportSlug,
    tournamentId,
    eventId,
    categoryId,
    sportId
) => {

    /* We need our fromTime and toTime strings,
     * as per backend restrictions to:
     * 1 - be rounded to the either minute 0
     * or to minute 5, and therefore...
     * 2 - not to contain any second ( have them
     * set to zero)
     */
    const fiveMinsCoeff = 1000 * 60 * 5;
    const nowDate = new Date();
    nowDate.setSeconds(0);
    const rounded5MinutesTime = new Date(Math.round(nowDate.getTime() / fiveMinsCoeff) * fiveMinsCoeff);
    // All the information attached from the point to the end is not valid for the backend
    const fromTime = (rounded5MinutesTime).toISOString().split('.')[0];
    const milliSecondsPerWeek = 6.048e+8;
    // All the information attached from the point to the end is not valid for the backend
    const toTime = (new Date( rounded5MinutesTime.getTime() + (milliSecondsPerWeek * 2) )).toISOString().split('.')[0];

    const urlEndpoint = buildSpectateUrl(MORE_GAMES_URL_ENDPOINT);

    const response = await post(urlEndpoint, {
        tournamentSlug,
        categorySlug,
        sportSlug,
        fromTime,
        toTime,
        tournamentId,
        eventId,
        categoryId,
        sportId,
    });
    if (response.ok) {
        const data = await response.json();

        return data;
    }

    return null;
};
